import { defineStore } from 'pinia'

export const useMessageStore = defineStore('messageStore', {
  state: () => ({
    successMessages: [] as string[],
  }),
  actions: {
    addMessage(message: string) {
      this.successMessages.push(message)
    },
    clearMessages() {
      this.successMessages = []
    },
    removeMessage(idx: number) {
      this.successMessages.splice(idx, 1)
    },
  },
})
